function formatLabelText(text) {
	return text
		.toLowerCase()
		.replace(/\*/g, '')
		.trim()
		.replace(/\b\w/g, (character) => character.toUpperCase());
}

function getAccessibleName(label, control) {
	const bcLabelText = label?.querySelector('.bcLabel')?.textContent?.trim();

	if (bcLabelText) {
		return formatLabelText(bcLabelText);
	}

	const labelText = label?.textContent?.trim();

	if (labelText) {
		return formatLabelText(labelText);
	}

	const placeholder = control.getAttribute('placeholder')?.trim();

	if (placeholder) {
		return formatLabelText(placeholder);
	}

	if (control.type === 'date' || control.id === 'BC_Dialogue_DOB_Input') {
		return 'Date of birth';
	}

	return '';
}

function associateBlueconicFieldLabels(root) {
	root.querySelectorAll('.fieldHolder').forEach((fieldHolder) => {
		const label = fieldHolder.querySelector('label');
		const control = fieldHolder.querySelector(
			'input:not([type="hidden"]):not([type="submit"]), select, textarea'
		);

		if (!control) {
			return;
		}

		if (!control.id) {
			const fieldId = fieldHolder.dataset.bcId || '';
			control.id = `bc-input-${
				fieldId.replace(/\W/g, '') || control.name || control.type
			}`;
		}

		const accessibleName = getAccessibleName(label, control);

		if (!accessibleName) {
			return;
		}

		if (label) {
			label.setAttribute('for', control.id);
		}

		// Explicit label/name for date inputs and when BlueConic hides or clears label text.
		control.setAttribute('aria-label', accessibleName);
	});
}

function demoteBlueconicFormHeading(root) {
	root.querySelectorAll('h1.bc-dialogue-title-text').forEach((heading) => {
		if (heading.dataset.skrewballHeadingDemoted === 'true') {
			return;
		}

		const replacement = document.createElement('h4');
		[...heading.attributes].forEach((attribute) => {
			replacement.setAttribute(attribute.name, attribute.value);
		});
		replacement.dataset.skrewballHeadingDemoted = 'true';
		replacement.innerHTML = heading.innerHTML;
		heading.replaceWith(replacement);
	});
}

function initBlueconicFormA11y() {
	const footerFormSection = document.querySelector(
		'.above-footer-form-section'
	);

	if (!footerFormSection) {
		return;
	}

	const enhanceForm = () => {
		demoteBlueconicFormHeading(footerFormSection);
		associateBlueconicFieldLabels(footerFormSection);
	};

	enhanceForm();

	const observer = new MutationObserver(enhanceForm);
	observer.observe(footerFormSection, {childList: true, subtree: true});
}

export function init() {
	initBlueconicFormA11y();
}
